"use client";

import { Button, Modal } from "@pamperedchef/design-system";

import { RichText } from "@/composites/foundation";
import * as styles from "./TermsModal.module.scss";

export interface TermsModalProps {
	isOpen: boolean;
	title: string;
	/** HTML body from the CMS. */
	body: string;
	buttonLabel?: string;
	onClose(): void;
}

/**
 * Terms & Conditions dialog for the gift offer: title, one legal paragraph and
 * a single "Understood" button. Stays mounted; `isOpen` toggles visibility
 * (DS Modal requirement).
 */
export function TermsModal({
	isOpen,
	title,
	body,
	buttonLabel = "Understood",
	onClose
}: TermsModalProps) {
	return (
		<Modal
			size="md"
			title={title}
			isOpen={isOpen}
			closeButtonLabel="Close terms and conditions"
			className={styles["terms-modal"]}
			setOpen={(value) => {
				const resolved =
					typeof value === "function" ? value(isOpen) : value;
				if (!resolved) onClose();
			}}
			onClosePress={onClose}
		>
			<div
				className={styles["terms-modal__content"]}
				data-component="TermsModal"
			>
				<RichText
					content={body}
					className={styles["terms-modal__body"]}
				/>
				<div className={styles["terms-modal__actions"]}>
					<Button kind="primary" size="lg" onPress={onClose}>
						{buttonLabel}
					</Button>
				</div>
			</div>
		</Modal>
	);
}
